







import { Component, Prop, Vue } from 'vue-property-decorator';
import CommentsList from './CommentsList.vue';
import CommentsForm from './CommentsForm.vue';
import { IComment } from '@/api/interface';

@Component({
  components: {CommentsForm, CommentsList}
})
export default class BlogComments extends Vue {
  @Prop({ default: 0 })
  private routeId!: number;

  @Prop({ default: '' })
  private dataOauth!: string;

  onAddComment(comment: IComment) {
    (this.$refs.list as CommentsList).addComment(comment);
  }
}
